import { render, staticRenderFns } from "./BiddersList.vue?vue&type=template&id=4301faf6&scoped=true"
import script from "./BiddersList.vue?vue&type=script&lang=js"
export * from "./BiddersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4301faf6",
  null
  
)

export default component.exports